/* Starlog font tester.
 * Activates only when URL has ?fonts=test or a pair is stored. Injects
 * Google Fonts + Fontshare stylesheets, mounts a floating UI panel
 * bottom-right, and toggles body classes (font-test-{pair}) that swap
 * fonts site-wide via CSS in starlog-custom.css.
 *
 * Selection persists across page navs via localStorage.
 * Normal visitors (no URL param, no stored pick) see the default theme.
 *
 * Three groups of pairs:
 *   - Free Google Fonts (loaded from Google CDN)
 *   - Free Fontshare (loaded from Fontshare CDN)
 *   - Paid trials (require trial font files uploaded to theme assets;
 *     @font-face declarations live in starlog-font-faces.css.liquid)
 */
(function () {
  if (typeof window === "undefined") return;

  // Live default is now Fraunces + Lora (set in theme's font_heading /
  // font_body). The "default" pair below means "no override, use the
  // theme defaults" -- which now resolves to Fraunces + Lora.
  // Other pairs override via body classes.
  var GROUPS = [
    {
      label: "Live default",
      pairs: [
        { id: "default",      label: "Fraunces + Lora",              note: "Current site default. Reset button at the bottom returns here." }
      ]
    },
    {
      label: "Top picks (paid trials)",
      pairs: [
        { id: "gtsectra",     label: "1. GT Sectra + GT Alpina",     note: "Grilli Type, ~$1k. Lapham's-tier coordinated system. My #1.", paid: true },
        { id: "editorialnew", label: "2. PP Editorial New",          note: "Pangram Pangram, ~$300. Single-family, contemporary editorial.", paid: true }
      ]
    },
    {
      label: "Strong free alternatives",
      pairs: [
        { id: "erode",        label: "3. Erode + Erode",             note: "Fontshare single-family. Contemporary editorial register." },
        { id: "gambarino",    label: "4. Gambarino + Erode",         note: "Fontshare. High-contrast Bodoni-feel display + sharp text." }
      ]
    },
    {
      label: "Solid free options",
      pairs: [
        { id: "dmserif",      label: "5. DM Serif Display + Spectral", note: "Google. Workhorse editorial pair." },
        { id: "boska",        label: "6. Boska + Quincy CF",         note: "Fontshare. Classical display + reading serif." },
        { id: "sentient",     label: "7. Sentient + Sentient",       note: "Fontshare. Variable serif single-family." }
      ]
    },
    {
      label: "Less suited for Starlog",
      pairs: [
        { id: "quincy",       label: "8. Quincy CF + Quincy CF",     note: "Fontshare. Classical, but a touch quiet for a relaunch." },
        { id: "cormorant",    label: "9. Cormorant + Source Serif",  note: "Google. Classical revival, generic register." },
        { id: "bodoni",       label: "10. Bodoni Moda + Spectral",   note: "Google. Reads as Vogue/Harper's, too fashion for sci-fi." },
        { id: "italiana",     label: "11. Italiana + Lora",          note: "Google. Italian fashion editorial, wrong register." },
        { id: "playfair",     label: "12. Playfair + Source Serif",  note: "Google. Overused editorial baseline." }
      ]
    },
    {
      label: "Compare against",
      pairs: [
        { id: "anton",        label: "Anton + Instrument Sans",      note: "Brutalist preset original (the previous live default)." }
      ]
    },
    {
      label: "Pending trial files",
      pairs: [
        { id: "marian",       label: "Marian Display + Marian Text", note: "Commercial Type, ~$1.5k. No free trial available.", paid: true }
      ]
    }
  ];

  // Flatten for easy lookup
  var ALL_PAIRS = GROUPS.reduce(function (acc, g) { return acc.concat(g.pairs); }, []);

  var STORAGE_KEY = "starlog-font-test-pair";
  var PARAM = "fonts";
  var PARAM_VAL = "test";

  function shouldActivate() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get(PARAM) === PARAM_VAL) return true;
      if (localStorage.getItem(STORAGE_KEY)) return true;
    } catch (e) { /* noop */ }
    return false;
  }

  function injectStylesheets() {
    if (!document.getElementById("starlog-ft-google")) {
      var link1 = document.createElement("link");
      link1.id = "starlog-ft-google";
      link1.rel = "stylesheet";
      link1.href = "https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;0,9..144,800;1,9..144,400;1,9..144,800&family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=DM+Serif+Display:ital@0;1&family=Spectral:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&family=Bodoni+Moda:ital,wght@0,400;0,700;0,900;1,400;1,700&family=Italiana&family=Source+Serif+4:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,700&family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400;1,700&family=Anton&family=Instrument+Sans:ital,wght@0,400;0,500;0,700;1,400&display=swap";
      document.head.appendChild(link1);
    }

    if (!document.getElementById("starlog-ft-fontshare")) {
      var link2 = document.createElement("link");
      link2.id = "starlog-ft-fontshare";
      link2.rel = "stylesheet";
      link2.href = "https://api.fontshare.com/v2/css?f[]=erode@400,500,700&f[]=boska@500,700&f[]=gambarino@500,700&f[]=quincy-cf@400,500,700&f[]=sentient@400,500,700&display=swap";
      document.head.appendChild(link2);
    }

    /* Paid trial @font-face declarations are loaded by theme.liquid as
     * starlog-font-faces.css (built from starlog-font-faces.css.liquid).
     * No JS injection needed. The browser only fetches font files when
     * CSS uses them, so this costs nothing for visitors who don't
     * activate a paid trial pair. */
  }

  function applyPair(pairId) {
    var body = document.body;
    if (!body) return;

    ALL_PAIRS.forEach(function (p) {
      body.classList.remove("font-test-" + p.id);
    });
    if (pairId && pairId !== "default") {
      body.classList.add("font-test-" + pairId);
    }
    try { localStorage.setItem(STORAGE_KEY, pairId || "default"); } catch (e) { /* noop */ }
  }

  function buildPanel(currentId) {
    var panel = document.createElement("div");
    panel.id = "starlog-ft-panel";
    panel.setAttribute("data-collapsed", "true");

    var html = [
      '<button type="button" class="ft-toggle" aria-label="Toggle font tester">',
        '<span class="ft-toggle-label">Fonts</span>',
        '<span class="ft-toggle-current"></span>',
      '</button>',
      '<div class="ft-body">',
        '<div class="ft-header">',
          '<h3>Font tester</h3>',
          '<button type="button" class="ft-close" aria-label="Close">&times;</button>',
        '</div>',
        '<div class="ft-list" role="radiogroup" aria-label="Font pair selection"></div>',
        '<div class="ft-footer">',
          '<p class="ft-help">Selection persists across pages. Add <code>?fonts=test</code> to any URL to reopen.</p>',
          '<button type="button" class="ft-reset">Reset to default</button>',
        '</div>',
      '</div>'
    ].join("");
    panel.innerHTML = html;

    var list = panel.querySelector(".ft-list");

    GROUPS.forEach(function (group) {
      var groupHeader = document.createElement("div");
      groupHeader.className = "ft-group-header";
      groupHeader.textContent = group.label;
      list.appendChild(groupHeader);

      group.pairs.forEach(function (p) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ft-pair" + (p.id === currentId ? " is-active" : "") + (p.paid ? " is-paid" : "");
        btn.dataset.pair = p.id;
        btn.setAttribute("role", "radio");
        btn.setAttribute("aria-checked", p.id === currentId ? "true" : "false");
        btn.innerHTML = [
          '<span class="ft-pair-radio"></span>',
          '<span class="ft-pair-text">',
            '<strong>' + p.label + '</strong>',
            '<span class="ft-pair-note">' + p.note + '</span>',
          '</span>',
          p.paid ? '<span class="ft-pair-badge">Trial</span>' : ''
        ].join("");
        btn.addEventListener("click", function () {
          applyPair(p.id);
          list.querySelectorAll(".ft-pair").forEach(function (b) {
            b.classList.toggle("is-active", b.dataset.pair === p.id);
            b.setAttribute("aria-checked", b.dataset.pair === p.id ? "true" : "false");
          });
          updateToggleLabel(panel, p);
        });
        list.appendChild(btn);
      });
    });

    panel.querySelector(".ft-toggle").addEventListener("click", function () {
      var collapsed = panel.getAttribute("data-collapsed") === "true";
      panel.setAttribute("data-collapsed", collapsed ? "false" : "true");
    });
    panel.querySelector(".ft-close").addEventListener("click", function () {
      panel.setAttribute("data-collapsed", "true");
    });
    panel.querySelector(".ft-reset").addEventListener("click", function () {
      applyPair("default");
      list.querySelectorAll(".ft-pair").forEach(function (b) {
        b.classList.toggle("is-active", b.dataset.pair === "default");
        b.setAttribute("aria-checked", b.dataset.pair === "default" ? "true" : "false");
      });
      updateToggleLabel(panel, ALL_PAIRS[0]);
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
    });

    var current = ALL_PAIRS.find(function (p) { return p.id === currentId; }) || ALL_PAIRS[0];
    updateToggleLabel(panel, current);

    return panel;
  }

  function updateToggleLabel(panel, pair) {
    var el = panel.querySelector(".ft-toggle-current");
    if (el) el.textContent = pair.label;
  }

  function init() {
    if (!shouldActivate()) return;

    injectStylesheets();

    var currentId = "default";
    try { currentId = localStorage.getItem(STORAGE_KEY) || "default"; } catch (e) { /* noop */ }
    applyPair(currentId);

    var panel = buildPanel(currentId);
    document.body.appendChild(panel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
